import { useState } from 'react';
import { Icon } from '../../../../layout/Icon.jsx';
import {
  useExpenseCategories,
  useCreateExpenseCategory
} from '../../hooks/useExpenseCategories.js';

export function CategoryPicker({ value, onChange, error }) {
  const { data: categories = [], isLoading } = useExpenseCategories();
  const createCat = useCreateExpenseCategory();
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState('');

  async function quickCreate() {
    if (!newName.trim()) return;
    const result = await createCat.mutateAsync({
      name: newName.trim(),
      color: '#FF7A1A',
      isActive: true
    });
    const cat = result?.category || result?.data || result;
    if (cat) {
      onChange?.(cat._id || cat.id);
      setAdding(false);
      setNewName('');
    }
  }

  return (
    <div>
      <label className="block text-xs font-semibold text-ink-2 mb-1">الفئة *</label>
      <div className="flex items-center gap-2">
        <select
          className={`input ${error ? 'border-red' : ''}`}
          value={value || ''}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={isLoading}
        >
          <option value="">— اختر فئة —</option>
          {categories
            .filter((c) => c.isActive !== false)
            .map((c) => (
              <option key={c._id || c.id} value={c._id || c.id}>
                {c.name}{c.isAuto ? ' (تلقائية)' : ''}
              </option>
            ))}
        </select>
        <button
          type="button"
          className="btn"
          style={{ padding: '8px 10px' }}
          onClick={() => setAdding((v) => !v)}
        >
          <Icon name="plus" size={14} />
        </button>
      </div>
      {adding ? (
        <div className="mt-2 p-2.5 rounded-[10px] bg-paper-2 flex items-center gap-2">
          <input
            className="input"
            placeholder="اسم الفئة الجديدة"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                quickCreate();
              }
            }}
          />
          <button
            type="button"
            className="btn btn-primary"
            disabled={createCat.isPending || !newName.trim()}
            onClick={quickCreate}
          >
            {createCat.isPending ? 'جاري...' : 'إضافة'}
          </button>
        </div>
      ) : null}
    </div>
  );
}
